import { ColumnDef } from 'features/common/hooks/useColumnSelection';
import { LotteryEntryStatus } from 'features/LotteryEntries/types';

export const LOTTERY_COLUMN_DEFS: ColumnDef[] = [
	{ key: 'email', labelKey: 'customFields-responses-lottery-table-email', minWidth: 200, priority: 1 },
	{ key: 'firstName', labelKey: 'customFields-responses-lottery-table-firstName', minWidth: 100, priority: 2 },
	{ key: 'lastName', labelKey: 'customFields-responses-lottery-table-lastName', minWidth: 100, priority: 3 },
	{ key: 'status', labelKey: 'customFields-responses-lottery-table-status', minWidth: 100, priority: 4 },
	{
		key: 'numberOfTickets',
		labelKey: 'customFields-responses-lottery-table-numberOfTickets',
		minWidth: 60,
		priority: 5,
	},
	{
		key: 'wheelchairAccess',
		labelKey: 'customFields-responses-lottery-table-wheelchairAccess',
		minWidth: 60,
		priority: 6,
	},
	{
		key: 'zipCode',
		labelKey: 'customFields-responses-lottery-table-zipCode',
		minWidth: 80,
		priority: 7,
		defaultHidden: true,
	},
	{
		key: 'optOutMailing',
		labelKey: 'customFields-responses-lottery-table-optOutMailing',
		minWidth: 60,
		priority: 8,
		defaultHidden: true,
	},
	{
		key: 'gender',
		labelKey: 'customFields-responses-lottery-table-gender',
		minWidth: 60,
		priority: 9,
		defaultHidden: true,
	},
	{ key: 'age', labelKey: 'customFields-responses-lottery-table-age', minWidth: 60, priority: 10, defaultHidden: true },
	{
		key: 'ethnicity',
		labelKey: 'customFields-responses-lottery-table-ethnicity',
		minWidth: 80,
		priority: 11,
		defaultHidden: true,
	},
	{
		key: 'householdIncome',
		labelKey: 'customFields-responses-lottery-table-householdIncome',
		minWidth: 100,
		priority: 12,
		defaultHidden: true,
	},
	{
		key: 'identifyGroups',
		labelKey: 'customFields-responses-lottery-table-identifyGroups',
		minWidth: 100,
		priority: 13,
		defaultHidden: true,
	},
];

// Base status taxonomy hues. PunchupTag re-tints the background prop (color-mix + chipColor),
// so it must receive the base hue — not a pre-tinted pastel — to yield the soft chip used on
// Orders/Comped. Passing a tint here would double-tint and wash the chip out / go off-taxonomy.
export const DEFAULT_STATUS_BACKGROUND = '#787B7E'; // inactive base hue

export const STATUS_BACKGROUND: Partial<Record<LotteryEntryStatus, string>> = {
	winner: '#7CC11F', // status-success
	claimed: '#3b82f6', // status-info
	pending: '#FACC15', // status-warning
	not_winner: DEFAULT_STATUS_BACKGROUND, // inactive
};
